<div class="main vaccine-detail">
    <div class="card">
        <h3 class="title">Vaccine Detail</h3>
        <div class="grid-container" *ngIf="vaccineDetail">
            <div class="grid-item">
                <label>Brand:</label>
                <span>{{ vaccineDetail.brand }}</span>
            </div>
            <div class="grid-item">
                <label>Arabic Brand:</label>
                <span>{{ vaccineDetail.arabicBrandName }}</span>
            </div>
            <div class="grid-item">
                <label>Quantity:</label>
                <span>{{ vaccineDetail.qty }}</span>
            </div>
            <div class="grid-item">
                <label>Application Type:</label>
                <span>{{ vaccineDetail.applicationName }}</span>
            </div>
            <div class="grid-item">
                <label>Batch Number:</label>
                <span>{{ vaccineDetail.batchNumber }}</span>
            </div>
            <div class="grid-item">
                <label>Classification:</label>
                <span>{{
                    splitByUpperCase(vaccineDetail.vaccineTypeName)
                }}</span>
            </div>
            <div class="grid-item">
                <label>Supplier:</label>
                <span>{{ vaccineDetail.supplierName }}</span>
            </div>
            <div class="grid-item">
                <label>Chick Age From:</label>
                <span>{{ vaccineDetail.chickAgeFrom }}</span>
            </div>
            <div class="grid-item">
                <label>Chick Age To:</label>
                <span>{{ vaccineDetail.chickAgeTo }}</span>
            </div>
            <div class="grid-item">
                <label>Farm:</label>
                <span>{{ vaccineDetail.farmName }}</span>
            </div>
            <div class="grid-item">
                <label>Expire Date:</label>
                <span>{{ vaccineDetail.expireDate | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="grid-item">
                <label>SKU:</label>
                <span>{{ vaccineDetail.sku }}</span>
            </div>
            <div class="grid-item">
                <label>Low Level Stock:</label>
                <span>{{ vaccineDetail.lowStockLevel }}</span>
            </div>
            <div class="grid-item">
                <label>Hatchery:</label>
                <span>{{ vaccineDetail.hatcheryName || 'N/A' }}</span>
            </div>
        </div>
    </div>
</div>
